/*
  wl-commerce.js — minimal, shared commerce chrome (P06/P18).
  Delegated listeners only; no framework. Handles:
    - wl-quantity-selector's +/- buttons (snippets/wl-quantity-selector.liquid)
  Add-to-cart itself stays a native form POST (ID-11: page cart, not a drawer,
  this stage) — no AJAX cart JS is introduced here.
*/
(function () {
  document.addEventListener('click', function (event) {
    var decrease = event.target.closest('[data-wl-quantity-decrease]');
    var increase = event.target.closest('[data-wl-quantity-increase]');
    var btn = decrease || increase;
    if (!btn) return;
    var wrapper = btn.closest('[data-wl-quantity]');
    if (!wrapper) return;
    var input = wrapper.querySelector('.wl-quantity__input');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var current = parseInt(input.value, 10) || min;
    var next = decrease ? Math.max(min, current - 1) : current + 1;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
